// ------------------------------------
// props 輸入需求 :
// props.hide : function( void )                    ( 開關按鈕 )
// props.data : object : { data: array }            (  )
// ------------------------------------


import React, { useState, useEffect } from 'react'
import REPersonal from './residentSetting/REPersonal/REPersonal';
import RESensor from './residentSetting/RESensor/RESensor';
import REAuto from './residentSetting/REAuto/REAuto';
// import HISNavBar from './historyRecord/HISNavBar';
import RESNavBar from './residentSetting/RESNavBar';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ConfigHandler from '../../actions/ConfigHandler';

const ResidentSetting =(props)=>{

    const [page, setPage] = useState(null);
    const {t} = useTranslation();
    const store = useSelector(state=>state.store_hisPage)
    useEffect(() => {
        if(store.page===0){ setPage(<REPersonal hide={props.hide} data={props.data}/>) }
        else if(store.page===1){ setPage(<RESensor hide={props.hide} data={props.data}/>) }
        else if(store.page===2){setPage(<REAuto hide={props.hide} data={props.data}/>)}
    }, [store]);
    return(
        <div className="pos-f z-3 wid-full hig-full top-0 left-0 fx-ccc bg-black" onClick={props.hide}>
            <div className="layout-history fx-d-c pad-30 l r" onClick={e=>e.stopPropagation()}>
                {/* navbar的項目 */}
                <RESNavBar
                    hide={props.hide}
                    isShow={[
                        true,
                        true,
                        ConfigHandler.isShowAIDC()
                    ]}
                    pageName={[t("RESIDENTS_SETTING.PERSONAL_INFO"), t('RESIDENTS_SETTING.CARE_SETTING'), t('RESIDENTS_SETTING.AUTO_SETTING')]}
                    pageDefault={props.page}/>
                <div className="h-85 w-100 fx-d-c font-m">
                    {page}
                </div>
            </div>
        </div>
    );

}
export default ResidentSetting